import React, { useState, useEffect, useCallback } from "react";
import AuditLogs from "./AuditLogs";

const WithAuditLogs = ({ id, title, fetchFn, onClose }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, total: 0 });

  const loadLogs = useCallback(
    (page = 1, pageSize = 12) => {
      setLoading(true);
      fetchFn(id, page)
        .then((res) => {
          // setLogs(res.results || []);
          setLogs(res || []);
          setPagination((prev) => ({
            ...prev,
            page,
            total: res.count || 0,
          }));
        })
        .finally(() => setLoading(false));
    },
    [fetchFn, id]
  );

  useEffect(() => {
    loadLogs();
  }, [id, loadLogs]);

  return (
    <AuditLogs
      title={title}
      loading={loading}
      logs={logs}
      onClose={onClose}
      page={pagination.page}
      total={pagination.total}
      onPageChange={loadLogs}
    />
  );
};

export default WithAuditLogs;
